import { validateListSize, validateOptionsList } from '../../../../utils';
import { CheckboxesInputDefinition } from '../../../../types';

// checkboxes input validation
export default (input: CheckboxesInputDefinition, errors: string[]) => {
  const { minItems, maxItems, options } = input;
  validateListSize(errors, minItems, maxItems);
  validateOptionsList(errors, options);
};
